import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBandsintownBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBandsintownBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8fb3d2fdbbc1dbbe44512251bf18b91f505f4b1d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '858f13a42b6be965ff524654a662417ba2777a0c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b83bdfc95276c90833ac3c6bfb2ef2b8bd3edcb4', d: "M4.5 17.88V4h2.69v11.346h7.632v-.743H7.958v-2.536h9.553v5.813z", fill: "#00CEC8" }), h("path", { key: '3a99c9b658a95a83005fdff8566a93edba2cc69d', d: "M14.822 4h2.664v7.12h-2.664zm-3.561 3.74h2.664v3.381h-2.664zm-.715 0H7.882v3.381h2.664z", fill: "#00CEC8" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-bandsintown-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bandsintown-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bandsintown-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBandsintownBranded$1);
            }
            break;
    } });
}

const CosmosIconBandsintownBranded = CosmosIconBandsintownBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBandsintownBranded, defineCustomElement };
